
export * from './connected-device.service';
export * from './discovery.service';
export * from './custom-device.service';
export * from './versions.service';
export * from './network.service';
export * from './log.service';
export * from './output-log.service';
export * from './process.service';
export * from './datetime.service';
export * from './env.service';

import {
  ConnectedDeviceService, DiscoveryService, CustomDeviceService, VersionsService, NetworkService, LogService, 
  OutputLogService, ProcessService, DateTimeService, EnvironemntService
} from '../services/index';

export const SYSMAN_SERVICES: Array<any> = [
  ConnectedDeviceService, DiscoveryService, CustomDeviceService, VersionsService, NetworkService, LogService, 
  OutputLogService, ProcessService, DateTimeService, EnvironemntService
];



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/index.ts